import types from './types';

export const startRequest = () => ({
  type: types.START_REQUEST,
});

export const endRequest = () => ({
  type: types.END_REQUEST,
});

export const openDialog = (dialogInfo) => ({
  type: types.OPEN_DIALOG,
  dialogInfo,
});

export const closeDialog = () => ({
  type: types.CLOSE_DIALOG,
});

export const openModal = (modalInfo) => ({
  type: types.OPEN_MODAL,
  modalInfo,
});

export const closeModal = (modalInfo) => ({
  type: types.CLOSE_MODAL,
});

export const checkAccess = (accessInfo) => ({
  type: types.CHECK_ACCESS,
  accessInfo,
});

export const getParam = (getParam) => ({
  type: types.GET_PARAM,
  getParam,
});

export const getAllGeneralPurposeMap = (generalPurposeMap) => ({
  type: types.GET_ALL_GENERAL_PURPOSE_MAP,
  generalPurposeMap,
});

// 担当者マスタID 設定
export const setContactId = (contactId) =>({
  type: types.SET_CONTACT_ID,
  contactId,
});

// 画面の活性状態設定
export const setReferenceMode = (referenceMode) => ({
  type: types.SET_REFERENCE_MODE,
  referenceMode,
});

// 画面警告設定
export const setGmnWarning = (Id, warning) => ({
  type: types.SET_GMN_WARNING,
  Id,
  warning,
});

export const setInitValues = (initValues) => ({
  type: types.SET_INIT_VALUES,
  initValues,
});

// ログイン時刻
export const setLoginTime = (loginTime) => ({
  type: types.SET_LOGIN_TIME,
  loginTime,
});

export default {
  startRequest,
  endRequest,
  openDialog,
  closeDialog,
  openModal,
  closeModal,
  checkAccess,
  setReferenceMode,
  setGmnWarning,
  setInitValues,
};

